import _ from 'lodash';
import { requiredIf } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import InvStratDiversifiedInfoDialog from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversified-info-dialog/inv-strat-diversified-info-dialog.vue';

export default {
  name: 'inv-strat-diversified',
  components: {
    InvStratDiversifiedInfoDialog,
  },
  mixins: [ToolkitMixin],
  data: () => ({
    showInfoDialog: false,
  }),
  computed: {
    assets() {
      return this.getItem.assets;
    },
    diversified: {
      get() {
        return this.getItem.diversified.diversified === 'yes' ? 'Yes' : 'No';
      },
      set(value) {
        this.setItem({
          diversified: {
            diversified: value === 'Yes' ? 'yes' : 'no',
          },
        });
      },
    },
    tags: {
      get() {
        const { diversified } = this.getItem;
        return diversified.assets.map(asset => asset.asset);
      },
      set(value) {
        const selectedAssets = _.cloneDeep(this.assets).filter(asset => value.includes(asset.name));
        const diversifiedAssets = selectedAssets.map(asset => ({
          asset: asset.name,
          risks: [],
          considerations: [],
          selection: '',
        }));
        this.setItem({
          diversified: {
            replace: true,
            assets: [
              ...diversifiedAssets,
            ],
          },
        });
      },
    },
    filteredAssets() {
      return _.cloneDeep(this.assets).filter(asset => !this.tags.includes(asset.name));
    },
  },
  validations: {
    tags: {
      required: requiredIf(function required() {
        return this.diversified === 'yes';
      }),
    },
  },
};
